import React from "react";

import TopNav from "./topNav";

const PublicLayout = props => {
  return (
    <div className="container-fluid p-0 public-layout-container">
      <TopNav />
      {props.children}
    </div>
  );
};

export default PublicLayout;
